const BASE_PATH_USER_ROLE_MANAGEMENT = '/account-management'

export function getAllAdmin(axiosPrivate) {
  return axiosPrivate.get(`${BASE_PATH_USER_ROLE_MANAGEMENT}/users`)
}

export function getAdminById(axiosPrivate, idAdmin) {
  return axiosPrivate.get(`${BASE_PATH_USER_ROLE_MANAGEMENT}/users/${idAdmin}`)
}

export function updateAdmin(axiosPrivate, idAdmin, payload) {
  return axiosPrivate.put(`${BASE_PATH_USER_ROLE_MANAGEMENT}/users/${idAdmin}/update`, payload)
}

export function addUser(axiosPrivate, payload) {
  return axiosPrivate.post(`${BASE_PATH_USER_ROLE_MANAGEMENT}/add`, payload)
}

export function deleteUser(axiosPrivate, id) {
  return axiosPrivate.delete(`${BASE_PATH_USER_ROLE_MANAGEMENT}/${id}/delete`)
}
